import * as React from 'react';
import { useState, useEffect } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import { Box, Dialog } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


export default function ForgetPassword(props) {
  const { disableButton, handleForgetPasswordValues, handleForgetPassword, handleShowingFormsValues } = props

  const handleClickSubmit = (e) => {
    handleForgetPassword()
  }
  return (
    <Box
      sx={{
        marginTop: 0.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Avatar sx={{ m: 0.5, bgcolor: 'secondary.main' }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" color="darkgoldenrod" variant="body1" >
        لطفا  شماره تلفن همراه خود راه وارد کنید
      </Typography>

      <Box noValidate sx={{ mt: 1 }}>
        <PhoneInput
          placeholder="شماره تلفن"
          countryCodeEditable={false}
          inputStyle={{ color: 'black', width: "220px" }}
          containerStyle={{ color: 'black', direction: "ltr" }}
          buttonStyle={{}}
          country={'ir'}
          enableSearch={true}
          onChange={phone => { handleForgetPasswordValues("phoneNumber", phone) }}
        />
        <Button
          disabled={disableButton}
          type="submit"
          fullWidth
          variant="contained"
          sx={{ mt: 1, mb: 1 }}
          onClick={handleClickSubmit}
        >
          ادامه
        </Button>
        <Grid container>
          <Container maxWidth="sx"  >
            <Link href="#" onClick={() => { handleShowingFormsValues("RegisterStep1") }} variant="body2">
              {"ثبت نام نکرده اید؟ثبت نام کنید"}
            </Link>
          </Container >

        </Grid>
      </Box>
    </Box>
  )
}